import { useState } from "react";
import { Droppable } from "react-beautiful-dnd";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import PrioritiesBoardGeneralCard from "../../PrioritiesBoardGeneralCard/PrioritiesBoardGeneralCard";
import AddWishListModal from "../AddWishListModal/AddWishListModal";

const columnColors = {
  backlog: '#6A9949',       // G04
  doing: '#97CA6F',         // G05 (current primary)
  'needs review': '#395718', // G02
  blocked: '#0D3310',       // G01
  closed: '#C2ECAA',        // G06
};

const columnTextColors = {
  backlog: '#E8F7DA',       // G07 light text
  doing: '#101010',         // dark text on light background
  'needs review': '#E8F7DA', // G07 light text on dark background
  blocked: '#E8F7DA',       // G07 light text on dark background
  closed: '#101010',        // dark text on light background
};

const Box = styled.div`
  display: flex;
  flex-direction: column;
  width: 250px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${props => columnColors[props.$status?.toLowerCase()] || 'var(--color-primary)'};
  border-radius: 4px;
  width: 100%;
  padding: 12px 26px;
  margin-bottom: 8px;
`;

const Heading = styled.h1`
  font-size: 12px;
  font-weight: 900;
  text-transform: uppercase;
  color: ${props => columnTextColors[props.$status?.toLowerCase()] || 'var(--color-bg-main)'};
`;

const Amount = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-bg-main);
  width: 24px;
  height: 24px;
  border-radius: 50%;
`;

const Span = styled.span`
  font-size: 12px;
  font-weight: 900;
  line-height: 1;
  color: var(--color-primary);
`;

const IconContainer = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--color-bg-sidebar);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16);
  margin-right: 16px;
  font-size: initial;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-primary);
`;

const Button = styled.div`
  margin-top: 22px;
  display: flex;
  align-items: center;
  background-color: var(--color-bg-sidebar);
  border-radius: 4px;
  padding: 20px;
  color: var(--color-text-secondary);
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  width: 100%;
  height: 80px;
  text-transform: capitalize;

  &:hover {
    background-color: var(--color-hover);
    color: var(--color-bg-main);
  }
`;

const Fallback = styled.p`
  font-size: 14px;
  color: var(--color-text-secondary);
  text-align: center;
  margin-top: 22px;
`;

const Swimlane = ({ heading, name, idx, cards = [], org = {} }) => {
  const [isOpen, setOpen] = useState(false);
  const toggle = () => setOpen((open) => !open);

  const isFirstColumn = idx === 0;

  return (
    <Box>
      <Header $status={heading}>
        <Heading $status={heading}>{heading}</Heading>
        <Amount>
          <Span>{cards.length}</Span>
        </Amount>
      </Header>
      <Droppable droppableId={name}>
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {cards.length < 1 ? (
              <Fallback>
                {isFirstColumn
                  ? "No tasks yet. Create one here!"
                  : "No tasks yet. Drop one here!"}
              </Fallback>
            ) : (
              cards.map((card, idx) => (
                <PrioritiesBoardGeneralCard
                  key={card.id}
                  card={card}
                  index={idx}
                  org={org}
                />
              ))
            )}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      {isFirstColumn && (
        <Button className="add-wishlist-plus-button" onClick={toggle}>
          <IconContainer>
            <FontAwesomeIcon icon={faPlus} />
          </IconContainer>
          Add new item
        </Button>
      )}
      {isOpen && <AddWishListModal isOpen={isOpen} toggle={toggle} />}
    </Box>
  );
};

export default Swimlane;
